<div class="job-order-detail-container">
  <div fxLayout="row" fxLayout.xs="column">
    <!-- MAIN COLUMN -->
    <div fxLayout="column" fxFlex="66">
      <div fxLayout="row" class="toolbar">
        <button class="primary" (click)="onBackClicked()" mat-flat-button>
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
      </div>
      <div fxLayout="row" fxFlex="1 100 100%">
        <app-card>
          <h3>Job Detail</h3>
          <!-- Name -->
          <div class="info-container">
            <div class="icon-container">
              <mat-icon>label</mat-icon>
            </div>
            <div class="content">
              <p>Name</p>
              <span>{{ jobOrderDetail?.code }}</span>
            </div>
          </div>

          <!-- Description -->
          <div *ngIf="jobOrderDetail?.description" class="info-container">
            <div class="icon-container">
              <mat-icon>description</mat-icon>
            </div>
            <div class="content">
              <p>Description</p>
              <span>{{ jobOrderDetail?.description }}</span>
            </div>
          </div>

          <!-- Difficulty -->
          <div *ngIf="jobOrderDetail?.difficulty" class="info-container">
            <div class="icon-container">
              <mat-icon>warning</mat-icon>
            </div>
            <div class="content">
              <p>Difficulty</p>
              <span>{{ jobOrderDetail?.difficulty }}</span>
            </div>
          </div>

          <!-- Notes -->
          <div *ngIf="jobOrderDetail?.note" class="info-container">
            <div class="icon-container">
              <mat-icon>note</mat-icon>
            </div>
            <div class="content">
              <p>Notes</p>
              <span>{{ jobOrderDetail?.note }}</span>
            </div>
          </div>
        </app-card>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxFlex="100" fxFlexFit>
        <app-card>
          <h3>Timings</h3>
          <div style="display: flex; flex-wrap: wrap">
            <!-- Start -->
            <div class="info-container">
              <div class="icon-container">
                <mat-icon>today</mat-icon>
              </div>
              <div class="content">
                <p>Start</p>
                <span>{{ jobOrderDetail?.startDate | date: "medium" }}</span>
              </div>
            </div>
            <!-- End -->
            <div class="info-container">
              <div class="icon-container">
                <mat-icon>event</mat-icon>
              </div>
              <div class="content">
                <p>End</p>
                <span>{{
                  jobOrderDetail?.endDate | date: "medium" || "--"
                }}</span>
              </div>
            </div>
            <!-- Total Time -->
            <div class="info-container">
              <div class="icon-container">
                <mat-icon>timelapse</mat-icon>
              </div>
              <div class="content">
                <p>Total Time</p>
                <span>{{ jobOrderDetail?.totalTimeAsHHmmss }}</span>
              </div>
            </div>
            <!-- Effective Time -->
            <div class="info-container">
              <div class="icon-container">
                <mat-icon>timer</mat-icon>
              </div>
              <div class="content">
                <p>Effective Time</p>
                <span>{{ jobOrderDetail?.effectiveWorkingTimeAsHHmmss }}</span>
              </div>
            </div>
            <!-- Loss Time -->
            <div class="info-container">
              <div class="icon-container">
                <mat-icon>delete</mat-icon>
              </div>
              <div class="content">
                <p>Loss Time</p>
                <span>{{ jobOrderDetail?.totalLostTimeAsHHmmss }}</span>
              </div>
            </div>
          </div>
          <div class="chart-container" *ngIf="chartData">
            <google-chart [data]="chartData"></google-chart>
          </div>
          <div class="chart-container" *ngIf="histogramData">
            <mat-slide-toggle (change)="wastedToggleHandler()">
              Wasted
            </mat-slide-toggle>
            <google-chart #histogram [data]="histogramData"></google-chart>
          </div>
        </app-card>
      </div>
    </div>

    <!-- RIGHT SIDE COLUMN -->
    <div fxLayout="column" fxFlex="33">
      <div fxLayout="row-reverse" fxLayout.xs="column" class="toolbar">
        <button class="secondary" (click)="onCsvDownloadClicked()" mat-flat-button>
          <mat-icon>download</mat-icon> JobOrder CSV
        </button>
      </div>
      <div fxLayout="row-reverse" fxLayout.xs="column" class="toolbar">
        <button class="secondary" (click)="onDataStatesCsvDownloadClicked()" mat-flat-button>
          <mat-icon>download</mat-icon> Data States CSV
        </button>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <app-card>
          <h3>Delivery</h3>
          <div class="calendar-container">
            <mat-calendar
              *ngIf="deliveryDate"
              #calendar
              [startAt]="deliveryDate"
              [selected]="deliveryDate"
            ></mat-calendar>
          </div>
        </app-card>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <app-card>
          <h3>Customer</h3>
          <div class="info-container">
            <div class="icon-container">
              <mat-icon>badge</mat-icon>
            </div>
            <div class="content">
              <span>{{ jobOrderDetail?.finalCustomer }}</span>
            </div>
          </div>
        </app-card>
      </div>
      <div
        *ngIf="
          jobOrderDetail != undefined &&
          jobOrderDetail.relatedDataStates.length > 0
        "
        fxLayout="row"
        fxLayout.xs="column"
      >
        <app-card>
          <h3>Data states</h3>

          <div *ngFor="let state of jobOrderDetail?.relatedDataStates">
            <div class="card-data-state">
              <span class="state-machine-name">{{ state.machineName }}</span>
              <span class="state-description">{{ state.description }}</span>
              <span class="footer">{{ state.dateTimeState }}</span>
            </div>
          </div>
        </app-card>
      </div>
    </div>
  </div>
</div>
